import type { CustomCssConfig, CustomCssVariables } from 'widget-components'
import type { Breakpoint } from 'widget-components/composables/breakpoints'
import { logger } from '@sentry/vue'
import { readonly, ref } from 'vue'

export type TooltipIconVisibility = 'mobile' | 'desktop' | 'both' | 'none'

export type WidgetOptions = {
    autoCloseWidget: boolean
    showCloseButton?: boolean
    customPagePreview: boolean
    inline: boolean
    customPageGridEnabled: boolean
    customCSSVariables?: Record<string, string>
    autoHeight?: boolean
    cssConfig?: CustomCssConfig
    cssVariables?: CustomCssVariables
    loading?: boolean
    tlHosted?: boolean
    allowUnpromptedWorkflowLeave?: boolean
    forcedBreakpoint?: Breakpoint
    explicitStart?: boolean
    hideFooter?: boolean
    tooltipIconVisibility?: TooltipIconVisibility
}

const widgetOptions = ref<WidgetOptions>({
    inline: false,
    autoCloseWidget: false,
    customPagePreview: false,
    customPageGridEnabled: true,
    autoHeight: false,
    loading: true,
    cssConfig: {},
    allowUnpromptedWorkflowLeave: false,
    explicitStart: false,
})

const setOptions = (options: Partial<WidgetOptions>) => {
    logger.trace('Set widget options', options)
    widgetOptions.value = {
        ...widgetOptions.value,
        ...options,
    }
}

function useWidgetOptions() {
    return {
        options: readonly(widgetOptions),
        setOptions,
    }
}

export default useWidgetOptions
